import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux-immutable";
import { createBrowserHistory } from "history";
import { routerMiddleware, syncHistoryWithStore } from "react-router-redux";
import Immutable from "immutable";
//Beware middleware! Be on your toes they might be your foes!
import combineActionsMiddleware from "redux-combine-actions";
import * as Reducers from "../reducers";
import InternalStateService from "./InternalStateService";
import translationService from "./TranslationService";
import getWindowSize from "../utils/windowSize";

let initialState = {
    data: {},
    config: {},
    //data and config for dashboards
    dashboards: {},
    //contains:
    //activeFlow - currently active Flow with isBlocking: true
    //isLoading - global laoding animation flag
    global: {},
    //app history
    routes: {},
    //global messages
    messages: {},
    //global notifications
    notifications: {},
    login: {},
    //application ui state (expand/collapse;loading etc.)
    uiState: {},
    //current window width/height and size category: S,M,L,XL
    windowSize: {},
    //used for action synchronization
    actions: {
        pendingUpdates: {}
    }
};

//adjusting initial redux state
let setInitialState = (state) => {
    let internalStateGlobalProps = InternalStateService.getGlobalProperties();
    let initialStoreGlobalProps = InternalStateService.getInitialStoreGlobalProperties();
    //Setting intial language, theme, known themes etc
    state.global = Object.assign(state.global, internalStateGlobalProps, initialStoreGlobalProps);
    //app rootPath (? unneeded)
    state.routes.rootPath = window.location.pathname;
    //initial windowSize
    state.windowSize = {
        size: getWindowSize().size
    };

    return state;
};

let init = () => {
    const routerHistory = createBrowserHistory({
        basename: InternalStateService.getWebConfig()["ROOT_PATH"]
    });
    const reducers = combineReducers(Reducers);
    const historyMiddleware = routerMiddleware(routerHistory);

    const store = configureStore({
        reducer: reducers,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: true,
                immutableCheck: false,
                serializableCheck: false
            }).concat([combineActionsMiddleware, historyMiddleware]),
        preloadedState: Immutable.fromJS(setInitialState(initialState)),
        devTools: window.__REDUX_DEVTOOLS_EXTENSION__
            ? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 })
            : (f) => f
    });

    syncHistoryWithStore(routerHistory, store, {
        selectLocationState: (store) => store.get("routes")
    });
    //Prev/Next browser navigation
    routerHistory.listen((location, action) => {
        //console.log("Location changed.");
        if (!location) {
            return;
        }
        if (action === "POP") {
            const reinitDashboard = InternalStateService.getActionByName(
                "dashboard.reinitDashboard"
            );
            store.dispatch(reinitDashboard(location));
        }
    });
    let unsavedChangesWarnings =
        InternalStateService.getGlobalProperties("unsavedChangesWarnings") !== undefined
            ? InternalStateService.getGlobalProperties("unsavedChangesWarnings")
            : true;
    //Prev/Next browser navigation - show warning message when application is in update mode
    if (unsavedChangesWarnings) {
        routerHistory.block((location, action) => {
            if (action === "POP" && store.getState().getIn(["global", "applicationUpdateMode"]))
                return translationService.translate("unsavedChanges");
        });
    }

    return {
        store: store
    };
};

export default {
    init
};
